import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Tooltip, ListItemButton } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import BookIcon from '@mui/icons-material/Book';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PaymentIcon from '@mui/icons-material/Payment';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import StorefrontIcon from '@mui/icons-material/Storefront';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import { useLocation, Link } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';

const allMenuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin', roles: ['superadmin'] },
  { text: 'Events', icon: <EventIcon />, path: '/admin/events', roles: ['superadmin'] },
  { text: 'Users', icon: <PeopleIcon />, path: '/admin/users', roles: ['superadmin'] },
  { text: 'Packages', icon: <CategoryIcon />, path: '/admin/packages', roles: ['superadmin'] },
  { text: 'Bookings', icon: <BookIcon />, path: '/admin/bookings', roles: ['superadmin'] },
  { text: 'Tickets', icon: <ConfirmationNumberIcon />, path: '/admin/tickets', roles: ['superadmin'] },
  { text: 'Payments', icon: <PaymentIcon />, path: '/admin/payments', roles: ['superadmin'] },
  { text: 'Notifications', icon: <NotificationsIcon />, path: '/admin/notifications', roles: ['superadmin'] },
  { text: 'Storage', icon: <CloudUploadIcon />, path: '/admin/storage', roles: ['superadmin'] },
  { text: 'Booths', icon: <StorefrontIcon />, path: '/admin/booths', roles: ['superadmin'] },
  { text: 'Speakers', icon: <RecordVoiceOverIcon />, path: '/admin/speakers', roles: ['superadmin'] },
  { text: 'CMS', icon: <CategoryIcon />, path: '/admin/cms', roles: ['superadmin'] },
  { text: 'Reports', icon: <BarChartIcon />, path: '/admin/reports', roles: ['superadmin'] },
  { text: 'Settings', icon: <SettingsIcon />, path: '/admin/settings', roles: ['superadmin'] },
];

function SuperAdminSidebar({ mini }) {
  const location = useLocation();
  const { profile } = useProfile() || {};
  const user = profile || JSON.parse(localStorage.getItem('user') || '{}');
  const normalizeRoles = (r) => {
    if (!r) return [];
    if (Array.isArray(r)) return r.map(x => String(x).trim().toLowerCase()).filter(Boolean);
    if (typeof r === 'string') return r.split(/[,;|]/).map(x => String(x).trim().toLowerCase()).filter(Boolean);
    return [String(r).trim().toLowerCase()];
  };
  const roles = normalizeRoles(user.role);
  const rolesSet = new Set(roles);
  let menuItems = [];
  if (rolesSet.has('superadmin') || rolesSet.has('admin')) {
    menuItems = allMenuItems.slice();
  } else {
    menuItems = allMenuItems.filter(item => Array.isArray(item.roles) && item.roles.some(r => rolesSet.has(String(r).toLowerCase())));
  }
  return (
    <List sx={{ width: mini ? 60 : 240, bgcolor: 'background.paper', height: '100%', boxShadow: 2, transition: 'width 0.3s' }}>
      {menuItems.map((item) => (
        <Tooltip title={mini ? item.text : ''} placement="right" arrow key={item.text}>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                borderRadius: 2,
                my: 0.5,
                bgcolor: location.pathname === item.path ? 'primary.main' : 'background.paper',
                color: location.pathname === item.path ? 'primary.contrastText' : 'text.primary',
                fontWeight: location.pathname === item.path ? 'bold' : 'normal',
                boxShadow: location.pathname === item.path ? 3 : 0,
                minHeight: 48,
                justifyContent: mini ? 'center' : 'flex-start',
                px: mini ? 1 : 2,
                transition: 'background 0.2s',
              }}
            >
              <ListItemIcon sx={{ color: location.pathname === item.path ? 'primary.contrastText' : 'text.secondary', minWidth: 0, mr: mini ? 0 : 2, justifyContent: 'center' }}>{item.icon}</ListItemIcon>
              {!mini && <ListItemText primary={item.text} />}
            </ListItemButton>
          </ListItem>
        </Tooltip>
      ))}
    </List>
  );
}

export default SuperAdminSidebar;
